<template>
  <div id="case-search">
    <div class="country">
      <el-radio-group v-model="radio">
        <el-radio :label="1">全部</el-radio>
        <el-radio :label="2">美国</el-radio>
        <el-radio :label="3">日本</el-radio>
        <el-radio :label="4">国内</el-radio>
      </el-radio-group>
    </div>
    <div class="input">
      <el-input
        placeholder="请输入病种"
        v-model="input"
        class="input-with-select"
      >
        <el-button
          type="primary"
          slot="append"
          icon="el-icon-search"
          @click="handleSearchClick"
        ></el-button>
      </el-input>
      <el-button
        type="primary"
        icon="el-icon-edit"
        class="edit"
        @click="handleEditClick"
        >写看病日记</el-button
      >
      <el-button class="question">问答</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseSearch", // 搜索
  components: {},
  data() {
    return {
      input: "",
      select: "",
      radio: 1
    };
  },
  mounted() {},
  methods: {
    // 搜索
    handleSearchClick() {},
    // 写看病日记
    handleEditClick() {},
    // 问答
    handleQuestionClick() {}
  }
};
</script>

<style lang="scss" scoped>
#case-search {
  height: 100px;
  overflow: hidden;
  .country {
    text-align: left;
    margin: 10px;
  }
  .input {
    margin: 10px;
    .input-with-select {
      width: 60%;
    }
    .edit {
      margin-left: 32px;
    }
    .question {
      margin-left: 22px;
    }
  }
}
</style>
